import React from "react";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

function Policies() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const goToPage = () => {
    navigate("/AddLocations");
  };

  const handleSearchChange = (event) => {
    // Update searchText when typing in TextField
  };
  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Accounts</Link>
                <Link underline="none">Policies</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Policies
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box sx={styles.box_containerbody_policies}>
          <Grid item xs={12} p={1}>
            <Typography variant="body1" align="left">
              SECVISION (PRIVATE) LIMITED (hereinafter referred to as “we” or
              “us” or “our”) respects the privacy of our users (hereinafter
              referred to as “user” or “you”). This Privacy Policy explains how
              we collect, use, disclose, and safeguard your information when you
              visit our ESKAIY-ERP hosted at erp.eskaiy.com website Please read
              this privacy policy carefully. If you do not agree with the terms
              of this privacy policy, please do not access the site.
            </Typography>
          </Grid>

          <Grid item xs={12} p={1}>
            <Typography variant="body1" align="left">
              We reserve the right to make changes to this Privacy Policy at any
              time and for any reason. We will alert you about any changes by
              updating the “Last Updated” date of this Privacy Policy. Any
              changes or modifications will be effective immediately upon
              posting the updated Privacy Policy on the Site, and you waive the
              right to receive specific notice of each such change or
              modification.
            </Typography>
          </Grid>

          <Grid item p={1} xs={12}>
            <Typography variant="body1" align="left">
              You are encouraged to periodically review this Privacy Policy to
              stay informed of updates. You will be deemed to have been made
              aware of, will be subject to, and will be deemed to have accepted
              the changes in any revised Privacy Policy by your continued use of
              the Site after the date such revised Privacy Policy is posted.
            </Typography>
          </Grid>
        </Box>{" "}
      </Box>
    </div>
  );
}

export default Policies;
